import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Row, Col, Button, Form } from "react-bootstrap";
import {createCompany, getAllBanks} from "../../../middleware/backend_hepler";
import FormInput from "../../../components/FormInput";
import { useNavigate } from 'react-router-dom';
import SelectInput from "../../../components/SelectInput";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateCompanyForm = () => {
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const navigate = useNavigate();

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await getAllBanks();
        const banksData = response.data.map((bank) => ({
          value: bank.bank_id,
          label: bank.bank_name,
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setBanks(banksData);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };
    fetchBanks();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await createCompany(data);
      setLoading(false);
      navigate("/companylist", {
        state: { successMessage: "Company created successfully!" },
      });
    } catch (error) {
      setLoading(false);
      console.error("Error for company creation:", error);
      toast.error("Failed to create company. Please try again.");
    }
  };

  return (
    <div className="edit-all-loan-container">
      <div className="edit-back-icon">
        <div
          className="edit-back-text"
          onClick={() => navigate("/companylist")}
        >
          &lt; Go Back
        </div>
      </div>
      <h2>Company</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sections personal-details-sections">
            <h4>Company Details</h4>
            <Row>
              <Col md={6}>
                <FormInput
                  name="company_name"
                  label="Company Name"
                  registerOptions={{ required: "Company Name is required" }}
                  required
                />
              </Col>
              <Col md={6}>
                <FormInput
                  name="company_pincode"
                  label="Company Pincode"
                  type="number"
                />
              </Col>
              <Col md={6}>
                <SelectInput
                  name="bank_list"
                  label="Bank List"
                  options={banks}
                  isMulti={true}
                  registerOptions={{
                    required: "Bank List is required",
                  }}
                />
              </Col>
            </Row>
          </div>
          <div className="button-container mt-4 text-center">
            <Button
              variant="success"
              type="submit"
              className="custom-submit-button"
            >
              Submit
            </Button>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateCompanyForm;
